'use strict';

import {
	getOptionsFromDataset,
} from '../../util/dom.js';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	const $mobileMenu = $container.find('[data-mobile-menu]');

	// Init lib only if we need to
	if ($mobileMenu.length > 0) {
		const datasetOptions = getOptionsFromDataset($mobileMenu[0], 'mobileMenu', true);

		const menuContainer = $mobileMenu[0];
		const $headerSelectors = $container.find('.header [data-toggle-selector]');
		const $headerIcons = $container.find('.header [data-toggle-user]');
		let menu;

		const initMobileMenu = () => {

			if (!menu) {
				// Wrap page content
				if ($('#mmenu_offcanvas').length === 0) {
					$('body > *').wrapAll('<div id="mmenu_offcanvas"></div>');
				}

				let navbars = [];

				if (datasetOptions.navbars) {
					navbars = datasetOptions.navbars;
				}
				else {
					if (!mpro.config.mobile.menu.expandable) {
						navbars = [
							{
								'position': 'top',
								'content': [
									'prev',
									'title',
									'close'
								]
							}
						];
					}
					else if (mpro.config.mobile.menu.title && mpro.config.mobile.menu.title.trim()) {
						navbars = [
							{
								'position': 'top',
								'content': [
									'prev',
									'title',
									'close'
								]
							}
						];
					}
	
					if ($headerSelectors.length > 0 || $headerIcons.length > 0) {
						navbars.push(
							{
								'position': 'bottom',
								'content': [
									'<div class="mobile-menu-footer"><div class="mobile-menu-icons-container"></div><div class="mobile-menu-selector-container"></div></div>'
								]
							}
						);
					}
				}

				// Init mobile menu plugin
				menu = new Mmenu(menuContainer, {
					hooks: {
						'open:before': function () {
							// Toggle header
							$('#mmenu_offcanvas').off('transitionend.toggle-header');
							$('#mmenu_offcanvas').addClass('mm-page').addClass('mm-slideout');
							$(this.node.menu).css({ 'display': 'flex' });
							$(this.node.wrpr)
								.removeClass('mm-wrapper--position-left')
								.removeClass('mm-wrapper--position-right')
								.addClass('mm-wrapper--position-' + this.opts.offCanvas.position);
							const viewport = document.querySelector("meta[name=viewport]");
							viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no');

							const windowScroll = window.scrollY;
							const wrapper = document.querySelector('.mm-wrapper');
							wrapper.style.position = 'fixed';
							wrapper.style.top = `-${windowScroll}px`;
							wrapper.style.width = '100%';

							$('.floating-wpp').hide();
						},
						'close:after': function () {
							const self = this;
							// Toggle header
							$('#mmenu_offcanvas').one('transitionend.toggle-header', function(e){
								$('#mmenu_offcanvas').removeClass('mm-page').removeClass('mm-slideout');
								$(self.node.menu).css({ 'display': 'none' });
								$(self.node.wrpr).removeClass('mm-wrapper--position-' + self.opts.offCanvas.position);
								const viewport = document.querySelector("meta[name=viewport]");
								viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=5');

								const wrapper = document.querySelector('.mm-wrapper');
								const scrollY = wrapper.style.top;
								wrapper.style.position = '';
								wrapper.style.top = '';
								wrapper.style.width = '';
								document.documentElement.style.scrollBehavior = 'auto';
								window.scrollTo(0, parseInt(scrollY || '0') * -1);
								document.documentElement.style.scrollBehavior = 'smooth';

								$('.floating-wpp').show();
							});
						},
						'openPanel:before': function (panel) {
							const $panel = $(panel);
							const $title = $panel.find('.mm-navbar__title');
							const $trigger = $(this.node.menu).find("[href='#" + $panel.prop('id') + "'].mm-btn_next");

							// Add the corect link to the title
							if ($trigger.length === 1) {
								const $triggerParent = $trigger.closest('li');
								if ($triggerParent.length && $triggerParent.data('url')) {
									$title.attr('href', $triggerParent.data('url'));
								}
							}
						},
						'openPanel:after': function (panel) {
							const $panel = $(panel);
							$panel.addClass('mm-panel--opened');
						},
						'closePanel:after': function (panel) {
							const $panel = $(panel);
							$panel.removeClass('mm-panel--opened');
						},
					},
					slidingSubmenus: !mpro.config.mobile.menu.expandable,
					theme: 'white',
					offCanvas: {
						position: mpro.config.mobile.menu.offcanvas_position || 'left',
					},
					backButton: {
						close: true,
					},
					lazySubmenus: {
						load: true,
					},
					navbar: {
						'add': false,
						'title': mpro.config.mobile.menu.title || ' ',
					},
					navbars: navbars,
				}, {
					offCanvas: {
						page: {
							selector: '#mmenu_offcanvas',
						},
					},
				});

				// Move the language selector into the mobile menu
				const $iconsContainer = $container.find('.mobile-menu-icons-container');
				const $selectorContainer = $container.find('.mobile-menu-selector-container');

				// First init
				if ($selectorContainer.children().length === 0) {
					if ($headerIcons.length > 0) {
						$iconsContainer.empty();
						$headerIcons.each(function () {
							const $jThis = $(this).clone(true);
							$.each($jThis.data(), function (i) {
								$jThis.removeAttr('data-' + i).removeAttr('class').find('> *').removeAttr('class');
								$jThis.addClass('mobile-menu-user btn btn-icon');
								$iconsContainer.append($jThis);
							});

							const $iconText = $jThis.clone(true);
							$iconText.html($iconText.attr('title'));
							$iconsContainer.append($iconText);
						});
					}
					if ($headerSelectors.length > 0) {
						// Clone the element to the new position in mobile menu (including bound events) and add button classes
						const $menuSelectors = $headerSelectors.clone(true);
						$menuSelectors.each(function (i) {
							this.classList.add('btn', 'btn-icon');
							$selectorContainer.append($menuSelectors);
						});
					}
				}

				// Open menu sections
				if (mpro.config.mobile.menu.expandable) {
					$(menu.node.pnls).find('[do-expand]').each(function () {
						menu.API.openPanel(this);
					});
				}
			}
		};

		/******************************************************************************************************************/

		// Detect window size
		// const mediaObjectMobileFilters = window.matchMedia('(max-width: 992px)');
		// const handleMediaMobileFiltersChange = async (e) => {
			// Check if the media query is true
			// if (e.matches) {

				const $menuToggle = $container.find('[data-menu-toggle]');

				if ($menuToggle.length > 0 && $menuToggle.is(':visible')) {
					// mediaObjectMobileFilters.removeEventListener('change', handleMediaMobileFiltersChange);

					// Import mmenu-js lib
					// @ts-ignore
					const { default: Mmenu } = await import('mmenu-js');

					initMobileMenu();

					$('#mmenu_offcanvas').removeClass('mm-page').removeClass('mm-slideout');

					$menuToggle.on('click', (e) => {
						e.preventDefault();

						menu.API.open();
					});
				}
			// }
		// };
		// // Register event listener
		// mediaObjectMobileFilters.addEventListener('change', handleMediaMobileFiltersChange);
		// // Initial check
		// await handleMediaMobileFiltersChange(mediaObjectMobileFilters);
	}
});
